var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "span",
        {
          staticClass: "boss-interview-candidate-date-schedule-name",
          attrs: { "data-test": "schedule-name" },
        },
        [_vm._v(_vm._s(_vm.schedule.name))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "float-right boss-button boss-interview-candidate-date-schedule-button",
          attrs: { "data-test": "edit-button" },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "interviewCandidateDateEdit",
                params: { id: _vm.schedule.id },
              })
            },
          },
        },
        [
          _c("span", { staticClass: "boss-icon-pencil" }),
          _vm._v(" "),
          _c("span", { staticClass: "boss-button-new-text" }, [
            _vm._v("編集する"),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    !_vm.isPublishing
      ? _c(
          "div",
          {
            staticClass: "boss-interview-candidate-date-schedule-text-parent",
            attrs: { "data-test": "not-publishing" },
          },
          [
            _c(
              "p",
              {
                staticClass:
                  "boss-interview-candidate-date-schedule-text-child",
              },
              [
                _vm._v(
                  "\n      掲載中、あるいは今後掲載予定の求人がある場合に、日程が表示されます。\n    "
                ),
              ]
            ),
          ]
        )
      : !_vm.isLinkedJob
      ? _c(
          "div",
          {
            staticClass: "boss-interview-candidate-date-schedule-text-parent",
            attrs: { "data-test": "not-Linked-job" },
          },
          [_vm._m(0)]
        )
      : _c(
          "div",
          {
            staticClass: "boss-interview-candidate-date-schedule-display-dates",
            attrs: { "data-test": "displayDate" },
          },
          _vm._l(_vm.schedule.displayDates, function (displayDate, j) {
            return _c("div", { key: "display-date-" + j }, [
              _c(
                "div",
                {
                  staticClass:
                    "boss-interview-candidate-date-schedule-display-date",
                  attrs: { "data-test": "display-date-" + j },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(j + 1) +
                      ". " +
                      _vm._s(_vm._f("formatDate")(displayDate)) +
                      "\n      "
                  ),
                ]
              ),
            ])
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "boss-interview-candidate-date-schedule-text-child" },
      [
        _vm._v("\n      応募者へ表示されていません。"),
        _c("br"),
        _vm._v("利用する場合は求人設定で"),
        _c("br"),
        _vm._v("カレンダーを選択してください。\n    "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }